var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAcUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1665 37.3332V29.7248L11.2082 35.5915L8.6415 33.0248L17.1665 24.4998V20.8332H13.4998L4.97484 29.3582L2.40817 26.7915L8.27484 20.8332H0.666504V17.1665H8.27484L2.40817 11.2082L4.97484 8.6415L13.4998 17.1665H17.1665V13.4998L8.6415 4.97484L11.2082 2.40817L17.1665 8.27484V0.666504H20.8332V8.27484L26.7915 2.40817L29.3582 4.97484L20.8332 13.4998V17.1665H24.4998L33.0248 8.6415L35.5915 11.2082L29.7248 17.1665H37.3332V20.8332H29.7248L35.5915 26.7915L33.0248 29.3582L24.4998 20.8332H20.8332V24.4998L29.3582 33.0248L26.7915 35.5915L20.8332 29.7248V37.3332H17.1665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcUnit);
export default __webpack_public_path__ + "static/media/icon_ac_unit.29020c148421ff0113b870f73358ba66.svg";
export { ForwardRef as ReactComponent };